import {titleText} from "../ArraysTexts/TitleText";


function ShopTitle({title}){
    return (
    <span className="ucp-title shop-title">{title}</span>
    )
}
export default ShopTitle;